import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { IRuoloUor, IUor, IUser, IUserNotifications } from "../shared/interfaces";

const controller = 'UserNotifications';




const addUserNotifications = (aooId: number, uorId: number, userId: string, userNotifications: Partial<IUserNotifications[]>, cancelToken?: CancelToken): Promise<IUser> => {
    return axiosInstance.post(`${controller}/${aooId}/${uorId}/AddUserNotifications`, userNotifications, { cancelToken: cancelToken, params: { userId } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const updateUserNotifications = (aooId: number, uorId: number, userId: string, userNotifications: Partial<IUserNotifications[]>, cancelToken?: CancelToken): Promise<IUser> => {
    return axiosInstance.post(`${controller}/${aooId}/${uorId}/UpdateUserNotifications`, userNotifications, { cancelToken: cancelToken, params: { userId } })
        .then(result => result.data)
        .catch(error => { 
            return Promise.reject(error);
        });
}

const deleteAllUserNotificationsInUorForSelectedUser = (aooId: number, uorId: number, userId: string, cancelToken?: CancelToken): Promise<IUser> => {
    return axiosInstance.post(`${controller}/${aooId}/${uorId}/DeleteAllUserNotificationsInUorForSelectedUser`,null, { cancelToken: cancelToken, params: { userId: userId } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

export default {
    addUserNotifications,
    updateUserNotifications,
    deleteAllUserNotificationsInUorForSelectedUser,
}
